let modalIndex = 0;

function modalIncrease() {
    modalIndex++;
}

export {modalIndex, modalIncrease};


// WEBPACK FOOTER //
// ./src/components/modal/q.js